import uuidv4 from 'uuid/v4';

export const handleAreaClick = (x, y, ctx, areaPoints, controlData, setAreaPoints, setMousePos, dispatch, createNewArea, setSelectedArea) => {
  const clickRadius = 10;
  if (areaPoints.length >= 3) {
    const firstPoint = areaPoints[0];
    const distance = Math.sqrt(
      (x - firstPoint.x) ** 2 + (y - firstPoint.y) ** 2
    );
    if (distance <= clickRadius) {
      const fillColor = controlData.fillColor || '#0000ff';
      const opacity = controlData.fillOpacity;
      const r = parseInt(fillColor.slice(1, 3), 16);
      const g = parseInt(fillColor.slice(3, 5), 16);
      const b = parseInt(fillColor.slice(5, 7), 16);
      const newArea = {
        points: areaPoints,
        fillColor: `rgba(${r}, ${g}, ${b}, ${opacity})`,
        fillOpacity: controlData.fillOpacity,
        lineWidth: controlData.lineWidth,
        lineColor: controlData.lineColor,
        id: uuidv4(),
      };
      dispatch(createNewArea(newArea));
      dispatch(setSelectedArea(newArea));
      setAreaPoints([]);
      return true;
    }
  }
  setAreaPoints([...areaPoints, { x, y }]);
  setMousePos({ x, y });
  return false;
};

export const handleArrowClick = (x, y, ctx, arrowStart, controlData, setArrowStart, setMousePos, dispatch, createNewArrow, setSelectedArrow) => {
  if (!arrowStart) {
    ctx.beginPath();
    ctx.arc(x, y, 3, 0, 2 * Math.PI);
    ctx.fillStyle = controlData.lineColor;
    ctx.fill();
    setArrowStart({ x, y });
    setMousePos({ x, y });
  } else {
    const newArrowItem = {
      startX: arrowStart.x,
      startY: arrowStart.y,
      endX: x,
      endY: y,
      lineWidth: controlData.lineWidth,
      lineColor: controlData.lineColor,
      id: uuidv4(),
    };
    dispatch(createNewArrow(newArrowItem));
    dispatch(setSelectedArrow(newArrowItem));
    setArrowStart(null);
  }
};

export const handleTextClick = (x, y, ctx, controlData, dispatch, createNewText, setSelectedText) => {
  const text = prompt('Enter text:');
  if (text && text.trim()) {
    const newTextItem = {
      text,
      x,
      y,
      fontSize: controlData.fontSize || 16,
      fontFamily: controlData.fontFamily || 'Arial',
      textColor: controlData.textColor || controlData.lineColor || '#000',
      id: uuidv4(),
    };
    dispatch(createNewText(newTextItem));
    dispatch(setSelectedText(newTextItem));
    ctx.fillText(text, x, y);
  }
};

export const handleSquareClick = (x, y, ctx, squareStart, controlData, setSquareStart, setMousePos, dispatch, createNewSquare, setSelectedSquare) => {
  if (!squareStart) {
    ctx.beginPath();
    ctx.arc(x, y, 3, 0, 2 * Math.PI);
    ctx.fillStyle = controlData.lineColor;
    ctx.fill();
    setSquareStart({ x, y });
    setMousePos({ x, y });
  } else {
    const width = x - squareStart.x;
    const height = y - squareStart.y;
    const fillColor = controlData.fillColor || '#0000ff';
    const opacity = controlData.fillOpacity;
    const r = parseInt(fillColor.slice(1, 3), 16);
    const g = parseInt(fillColor.slice(3, 5), 16);
    const b = parseInt(fillColor.slice(5, 7), 16);
    const newSquare = {
      x: squareStart.x,
      y: squareStart.y,
      width,
      height,
      fillColor: `rgba(${r}, ${g}, ${b}, ${opacity})`,
      lineWidth: controlData.lineWidth,
      lineColor: controlData.lineColor,
      id: uuidv4(),
    };
    dispatch(createNewSquare(newSquare));
    dispatch(setSelectedSquare(newSquare));
    setSquareStart(null);
  }
};

export const handleCircleClick = (x, y, ctx, circleStart, controlData, setCircleStart, setMousePos, dispatch, createNewCircle, setSelectedCircle) => {
  // Don't create new circle if one is already selected
  if (controlData.selectedCircle) {
    return;
  }
  const defaultRadius = 50;
  const fillColor = controlData.fillColor || '#0000ff';
  // Use 0 opacity for lixaniPaint context, 0.2 for areaPlanning
  const fillOpacity = controlData.context === 'lixaniPaint' ? 0 : (controlData.fillOpacity || 0.2);
  const rgbaFillColor = fillColor.startsWith('#') 
    ? `rgba(${parseInt(fillColor.slice(1, 3), 16)}, ${parseInt(fillColor.slice(3, 5), 16)}, ${parseInt(fillColor.slice(5, 7), 16)}, ${fillOpacity})`
    : fillColor;
  
  const newCircle = {
    x,
    y,
    radiusX: defaultRadius,
    radiusY: defaultRadius,
    lineWidth: controlData.lineWidth || 2,
    lineColor: controlData.lineColor || '#000000',
    fillColor: rgbaFillColor,
    fillOpacity: fillOpacity,
    id: uuidv4(),
  };
  dispatch(createNewCircle(newCircle));
  dispatch(setSelectedCircle(newCircle));
};

export const handleLegendClick = (x, y, ctx, legendStart, controlData, setLegendStart, setMousePos, dispatch, createNewLegend, setSelectedLegend) => {
  if (!legendStart) {
    ctx.beginPath();
    ctx.arc(x, y, 3, 0, 2 * Math.PI);
    ctx.fillStyle = controlData.lineColor;
    ctx.fill();
    setLegendStart({ x, y });
    setMousePos({ x, y });
  } else {
    const width = x - legendStart.x;
    const height = y - legendStart.y;
    const newLegend = {
      x: legendStart.x,
      y: legendStart.y,
      width,
      height,
      items: [],
      backgroundColor: '#ffffff',
      borderColor: '#000000',
      borderWidth: 2,
      id: uuidv4(),
    };
    dispatch(createNewLegend(newLegend));
    dispatch(setSelectedLegend(newLegend));
    setLegendStart(null);
  }
};

export const handleIconClick = (x, y, selectedIcon, iconText, controlData, dispatch, createNewIcon, setSelectedIcon) => {
  const newIcon = {
    x,
    y,
    iconType: selectedIcon.name,
    iconPath: selectedIcon.icon,
    text: iconText,
    size: 24,
    color: controlData.lineColor || '#000000',
    id: uuidv4(),
  };
  dispatch(createNewIcon(newIcon));
  dispatch(setSelectedIcon(newIcon));
};